exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".social-icons{margin-top:2rem}.social-icons .social-icons-list li{float:left;margin-left:2rem;margin-bottom:1rem}.social-icons .social-icons-list li:first-of-type{margin-left:0}.social-icons .social-icons-list li .icon-link{cursor:pointer}.social-icons .social-icons-list li .icon-link img{display:inline;width:3.2rem;height:3.2rem}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader!./src/components/ui-SocialMediaIcons/_index.scss
 ** module id = 200
 ** module chunks = 0
 **/